
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/walks/[slug]",
      function () {
        return require("private-next-pages/walks/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/walks/[slug]"])
      });
    }
  